var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.userProfile
    ? _c(
        "v-form",
        [
          !_vm.userProfile.emailConfirmed
            ? _c(
                "v-container",
                { staticClass: "pt-8" },
                [
                  _vm.confirmationSent
                    ? _c("v-row", [
                        _vm._v(
                          " Confirmation sent. Please check your email account and refresh this page once you have confirmed your email to edit your profile. "
                        )
                      ])
                    : _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            [
                              _vm._v(
                                " Your email address is not confirmed. You should have recieved a confirmation email when you created your account. You cannot edit your profile until it is confirmed. Please click the button below to resend the confrimation email "
                              ),
                              _c(
                                "v-btn",
                                { on: { click: _vm.resendConfirmation } },
                                [_vm._v("Resend Confirmation")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                ],
                1
              )
            : _c(
                "v-container",
                [
                  _vm.errorMessage
                    ? _c(
                        "v-row",
                        { attrs: { justify: "" } },
                        [
                          _c(
                            "v-col",
                            [
                              _c("v-alert", { attrs: { type: "error" } }, [
                                _vm._v(" " + _vm._s(_vm.errorMessage) + " ")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6", "order-md": "2" } },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "d-flex justify-center justify-md-end"
                            },
                            [
                              _c("action-buttons", {
                                staticClass: "d-flex justify-end",
                                attrs: {
                                  state: "Edit",
                                  permissions: _vm.permissions,
                                  disabled: _vm.disableButtons,
                                  "is-dirty": _vm.isDirty
                                },
                                on: {
                                  save: _vm.saveChanges,
                                  cancel: _vm.handleCancel,
                                  close: _vm.handleClose
                                }
                              })
                            ],
                            1
                          )
                        ]
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6", "order-md": "1" } },
                        [
                          _c("div", { staticClass: "text-h5" }, [
                            _vm._v("Edit your profile!!!")
                          ])
                        ]
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "First Name",
                              rules: [_vm.requiredRule]
                            },
                            model: {
                              value: _vm.userProfile.firstName,
                              callback: function($$v) {
                                _vm.$set(_vm.userProfile, "firstName", $$v)
                              },
                              expression: "userProfile.firstName"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: "Last Name",
                              rules: [_vm.requiredRule]
                            },
                            model: {
                              value: _vm.userProfile.lastName,
                              callback: function($$v) {
                                _vm.$set(_vm.userProfile, "lastName", $$v)
                              },
                              expression: "userProfile.lastName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: { label: "Display Name" },
                            model: {
                              value: _vm.userProfile.displayName,
                              callback: function($$v) {
                                _vm.$set(_vm.userProfile, "displayName", $$v)
                              },
                              expression: "userProfile.displayName"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("div", { staticClass: "text-subtitle-1" }, [
                            _vm._v("Email Frequency")
                          ]),
                          _c(
                            "v-radio-group",
                            {
                              attrs: { row: "" },
                              model: {
                                value: _vm.emailFrequency,
                                callback: function($$v) {
                                  _vm.emailFrequency = $$v
                                },
                                expression: "emailFrequency"
                              }
                            },
                            [
                              _c("v-radio", {
                                attrs: { label: "None", value: "0" }
                              }),
                              _c("v-radio", {
                                attrs: { label: "Daily", value: "1" }
                              }),
                              _c("v-radio", {
                                attrs: { label: "Hourly", value: "2" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-color-picker", {
                            attrs: { mode: "hexa", "hide-mode-switch": "" },
                            model: {
                              value: _vm.backgroundHexColor,
                              callback: function($$v) {
                                _vm.backgroundHexColor = $$v
                              },
                              expression: "backgroundHexColor"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c(
                            "v-avatar",
                            { attrs: { color: _vm.iconColour, size: "40" } },
                            [
                              _vm.userProfile.icon
                                ? _c("v-icon", [
                                    _vm._v(
                                      " " + _vm._s(_vm.userProfile.icon) + " "
                                    )
                                  ])
                                : _c(
                                    "span",
                                    { class: _vm.fontColour + `--text` },
                                    [_vm._v(_vm._s(_vm.initials))]
                                  )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }